import { parseAsString, useQueryState } from 'nuqs'

export function useGlobalFilterSearchParams(key = 'search') {
  return useQueryState(key, parseAsString.withDefault(''))
}